import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const StaticSitemapEntriesRoutes: RouteRecordRaw = {
  path: '/static-sitemap',
  name: 'StaticSitemapEntriesModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageStaticSitemapRoute',
      component: () => import('./views/ManageStaticSitemapView.vue'),
      meta: {
        title: 'sitemap  ',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.staticSitemapEntries,
  },
}

export default (router: Router) => {
  router.addRoute(StaticSitemapEntriesRoutes)
}
